import { authSelectors } from 'ducks/auth'
import BulkActionButtons from 'elements/button/BulkActionButtons'
import { hasListBulkEditSupport } from 'elements/listBulkEdit/bulkEditRegistry'
import { useSelector } from 'react-redux'

export const useBulkActionButtons = (
  props: any,
  allowEdit: boolean,
  allowDelete: boolean,
  hasArchived: boolean = false,
  allowBulkSharing: boolean = true
) => {
  const connectedOrgs = useSelector(authSelectors.getActiveConnectedOrgs)
  const allowBulkEdit = allowEdit && connectedOrgs.length > 0
  const allowBulkDelete = allowDelete
  const enableBulkSharing = allowBulkSharing && allowBulkEdit

  const resource = typeof props.resource === 'string' ? props.resource : ''
  const enableListBulkEdit = Boolean(resource && hasListBulkEditSupport(resource) && allowEdit)

  if (allowBulkEdit || allowBulkDelete)
    return (
      <BulkActionButtons
        enableBulkArchive={hasArchived}
        enableBulkSharing={enableBulkSharing}
        enableBulkDelete={allowBulkDelete}
        enableListBulkEdit={enableListBulkEdit}
        {...props}
      />
    )

  return undefined
}
